import React from "react";
import { Layout, Button, Row, Col } from "antd";
import { Link, useLocation } from "react-router-dom";
import logo from '../../assets/img/wil.png';
import './style.css';

const { Header } = Layout;

const Navbar = () => {
  const location = useLocation(); // Get the current location

  return (
    <Layout className="layout">
      <Header className="sticky-navbar" style={{ padding: 0, height: '90px', lineHeight: '90px', background: '#F8F8FF' }}>
        <Row className="container" justify="space-between" align="middle" style={{ height: '100%' }}>
          <Col xs={20} sm={20} md={4}>
            <img
              src={logo}
              alt="Logo"
              style={{ height: '100px', paddingLeft: '20px' }}
            />
          </Col>
          <Col xs={0} sm={0} md={16}>
          </Col>
          <Col xs={4} sm={4} md={4} style={{ textAlign: 'right', lineHeight: '80px' }}>

            {/* {location.pathname !== "/sign_up" && (
              <Button type="primary" style={{ marginRight: "10px", width: '80px', height: '30px' }}>
                <Link style={{ textDecoration: 'none' }} to="/sign_up">Sign Up</Link>
              </Button>
            )} */}
          </Col>
        </Row>
      </Header>
    </Layout>
  );
};

export default Navbar;
